import type { StandardSchemaV1 } from '@standard-schema/spec';
import { useLocalStorage } from '@uidotdev/usehooks';
import { useValidatedStorage } from './useValidatedStorage';

export const useValidatedLocalStorage = <
    T extends NonNullable<unknown> | null,
>({
    key,
    schema,
    defaultValue,
}: {
    key: string;
    schema: StandardSchemaV1<T>;
    defaultValue: NoInfer<T>;
}) => {
    return useValidatedStorage({
        schema,
        defaultValue,
        // biome-ignore lint/correctness/useHookAtTopLevel: does not apply
        useStorage: () => useLocalStorage(key, defaultValue),
    });
};
